import React from 'react';
//import ReactJWPlayer from "react-jw-player";
import ReactPlayer from "react-player";

const DraftUploadedMedia = (props) => {
    return (
        <div className={"draft-uploaded-media"}>
            {props.kind === "image" ? (
                <img  alt={""} src={props.src} />
            ) : props.kind === "video" && (
                <ReactPlayer
                    playing={true}
                    className='react-player'
                    url={props.src}
                    width='100%'
                    height='100%'
                    controls={true}
                    config={
                        {
                            file: {
                                attributes: {
                                    controlsList: 'nodownload'
                                }
                            }
                        }
                    }
                />
            )}

        </div>
    )
};

export default DraftUploadedMedia;